<template>
  <div class="social" style="font-size:2em;">
    <a href="https://twitter.com/lab321" target="_blank">
      <i class="fa fa-twitter-square" aria-hidden="true"></i>
    </a>
    <a href="http://www.facebook.com/lab321.org" target="_blank">
      <i class="fa fa-facebook-square" aria-hidden="true"></i>
    </a>
    <a href="http://www.linkedin.com/company/500949" target="_blank">
      <i class="fa fa-linkedin-square" aria-hidden="true"></i>
    </a>
  </div>
</template>

<script>
  export default {
    name: 'Menu',
    data () {
      return {
        msg: ''
      }
    }
  };
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/parts/Social.vue